module.exports = __webpack_public_path__ + "static/media/data-management.e07d541c.svg";